import { Outlet } from "react-router-dom";
import { BottomNav } from "@/components/BottomNav";
import { CartBar } from "@/components/CartBar";
import { FloatingActions } from "@/components/FloatingActions";
import { isFullMenuMode } from "@/config/restaurantConfig";

// Shell for the main tabbed app (home / menu / order). In COMPANION_ONLY mode
// there is no menu/cart/order, so the cart bar and tab bar are not rendered.
export function AppShell() {
  const fullMenu = isFullMenuMode();
  return (
    <div className="emergent-pwa-scope relative mx-auto flex min-h-screen w-full max-w-md flex-col overflow-x-hidden bg-background">
      <main className="flex-1 pb-28">
        <Outlet />
      </main>
      {fullMenu && <CartBar />}
      <FloatingActions />
      {fullMenu && <BottomNav />}
    </div>
  );
}
